// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ArticleOverview{position:relative}.ArticleOverview .v-progress-linear{bottom:-10px;position:absolute;width:94%;z-index:10}.ArticleOverview img{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}.ArticleOverview h3{font-size:14px;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
